module.exports = __webpack_public_path__ + "public/img/通行权限Bg.70bd1ea0.png";